import { useEffect } from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import { DateField, AntdSelect, FormSelectAntd, FormInputAntd } from "components"
import { equipmentsValidationSchema } from "Schema"
import { EmployeeEquipmentIssuedInterface, GetEmployeeEquipmentIssuedInterface } from "@type/employees.types"
import useAppSelector from "hooks/useAppSelector"
import { selectCustomerOptions } from "store/Customers/customers.slice"
import AntdModal from "components/AntdModal"

export enum EquipmentType {
	CAP = "CAP",
	COAT = "COAT",
	WAIST = "WAIST",
	CHEST = "CHEST",
	INSIDE_LEG = "INSIDE_LEG",
	DRESS = "DRESS",
	COLLAR = "COLLAR",
	SHOES = "SHOES",
	GLOVES = "GLOVES",
	UNIFORM = "UNIFORM",
}

const EquipmentTypeArray = [
	{ name: "Hard Hat", value: EquipmentType.CAP },
	{ name: "Gloves", value: EquipmentType.GLOVES },
	{ name: "High Visibility Jacket", value: EquipmentType.COAT },
	// { name: "Waist", value: EquipmentType.WAIST },
	// { name: "Inside Leg", value: EquipmentType.INSIDE_LEG },
	{ name: "Dress", value: EquipmentType.DRESS },
	// { name: "Collar", value: EquipmentType.COLLAR },
	{ name: "Shoes", value: EquipmentType.SHOES },
	{ name: "Uniform", value: EquipmentType.UNIFORM },
]

interface Props {
	open: boolean
	issuedData?: GetEmployeeEquipmentIssuedInterface | null
	modalHandler: (open: boolean) => void
	IsSaving?: boolean
	onSubmit: (data: EmployeeEquipmentIssuedInterface) => void
}

const IssuedModal: React.FC<Props> = ({ open, issuedData = null, modalHandler, IsSaving = false, onSubmit }) => {
	const methods = useForm<EmployeeEquipmentIssuedInterface>({
		resolver: yupResolver(equipmentsValidationSchema),
	})
	const customersOptions = useAppSelector(selectCustomerOptions)
	const {
		handleSubmit,
		reset,
		watch,
		setValue,
		formState: { errors, isDirty },
	} = methods
	useEffect(() => {
		if (issuedData) {
			reset({
				...issuedData,
				customer: issuedData.customer._id,
				issueDate: issuedData?.issueDate,
				returnDate: issuedData?.returnDate,
				checked: issuedData?.checked,
				nextCheck: issuedData?.nextCheck,
			})
		} else reset({})
	}, [issuedData?._id])

	return (
		<AntdModal
			open={open}
			title={"Additional Details"}
			onCancel={() => modalHandler(false)}
			onOk={handleSubmit(onSubmit)}
			okText="Save"
			okButtonProps={{ loading: IsSaving, disabled: !isDirty }}
		>
			<div className="justify-center sm:flex sm:items-start">
				<FormProvider {...methods}>
					<form>
						<div className="flex flex-col gap-y-5">
							<div className="grid grid-cols-3 gap-y-2 gap-x-6">
								<FormSelectAntd
									disabled={!EquipmentTypeArray.length}
									label="Equipment"
									name="equipmentType"
									options={EquipmentTypeArray.map(type => ({
										label: type.name,
										value: type.value,
									}))}
								/>
								<FormInputAntd type="text" label="Quantity" name="quantity" />

								<FormInputAntd type="text" name="serialNumber" label="Size/Sr No." />
								<DateField
									label="Issued Date"
									setValue={setValue}
									errors={errors}
									watch={watch}
									name={"issueDate"}
								/>
								<DateField
									label="Return Date"
									setValue={setValue}
									watch={watch}
									errors={errors}
									name="returnDate"
								/>
								<DateField
									label="Checked"
									setValue={setValue}
									watch={watch}
									errors={errors}
									name="checked"
								/>
								<DateField
									label="Next Check"
									setValue={setValue}
									watch={watch}
									errors={errors}
									name="nextCheck"
								/>
								<FormInputAntd name="notes" label="Notes" type="text" />
								<FormInputAntd name="audit" label="Audit" type="text" />
								<AntdSelect
									disabled={!customersOptions.length}
									label="Customer"
									name="customer"
									size="middle"
									formValueSetter={setValue}
									selected={watch("customer") ?? ""}
									className="h-auto"
									isControlled={true}
									options={customersOptions}
									errors={errors}
								/>
							</div>
						</div>
					</form>
				</FormProvider>
			</div>
		</AntdModal>
	)
}

export default IssuedModal
